import { format, unwrapFunctionStore } from 'svelte-i18n';

import { studioSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const sigEditorActions = {
  element: 'div.page-header .btn-group > button',
  popover: {
    onPopoverRender: () => {
      const sigActions = document.querySelector('div.page-header .btn-group > button');

      if (sigActions) {
        sigActions.click();

        GLOBAL_DRIVER_OBJECT.highlight({
          element: 'div.hide--mobile.btn-group > ul.dropdown-menu',
          popover: {
            title: $format('label.TOURS.STUDIO.CLONE.SIG_EDITOR_ACTIONS.TITLE'),
            description: $format('label.TOURS.STUDIO.CLONE.SIG_EDITOR_ACTIONS.DESCRIPTION'),
            side: 'left',
            align: 'start',
            showButtons: ['next'],
            nextBtnText: $format('label.DONE'),
            onNextClick: () => {
              const studioButton = document.querySelector(
                '#signature-editor > div.page-header > div > div:nth-child(1) > div > nav > ol > li:nth-child(2) > a'
              );

              studioSettingsStore.subscribe((studio) => {
                studio.tours.cloneHasToured = true;
              })();

              if (studioButton) {
                studioButton.click();

                GLOBAL_DRIVER_OBJECT.destroy();
              }
            }
          }
        });
      }
    }
  }
};
